import React from 'react';
import Collapse, {Panel} from "rc-collapse";

const GiveAmountClient = ({amount}) => {

    return (
        <div className="form-row selected-bgr">
            <div className="form-row-item">
                <div className="form-element calculationLayout-element calculationLayout-width">
                    <div className="form-element-data static">
                        <Collapse>
                            <Panel
                                showArrow={false}
                                forceRender={true}
                                header="Выдать клиенту"
                                headerClass="block-datacollapse-header calculationLayout-header"
                                className="block-datacollapse-container calculationLayout-container collection-item font-bold"
                            >
                                <table className="table calculationLayout-table">
                                    <tbody>
                                    <tr>
                                        <td className={"selected-bgr"}>
                                            <p>1</p>
                                        </td>
                                        <td className={"selected-bgr"}>
                                            <p>Микрозаём</p>
                                        </td>
                                        <td className={"selected-bgr "}>
                                            <p>
                                                {amount
                                                    ? amount.toFixed(2)
                                                    : 0}{" "}
                                                руб.
                                            </p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </Panel>
                        </Collapse>
                    </div>
                </div>
            </div>
            <div className="form-row-item">
                <div className="form-element-data static">
                    <p className="big font-bold ">
                        {amount !== 0
                            ? amount.toFixed(2)
                            : 0}{" "}
                        руб.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default GiveAmountClient;
